/*eslint-disable*/
import React, { useRef, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Card from "react-bootstrap/Card";
import InfiniteScroll from "react-infinite-scroll-component";
import StarIcon from "@mui/icons-material/Star";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import CompanyJobDetail from "./CompanyJobDetail";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { IoIosArrowRoundBack } from "react-icons/io";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { TbBrandLinkedin } from "react-icons/tb";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { useSelector } from "react-redux";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Call from "../images/Call.png";
import Email from "../images/email.png";
import Tag from "../images/tag.png";
import Chat from "../images/chat.png";
import Note from "../images/note.png";
import { companiesManagementSelector } from "./redux/selector";
import Key from "../../clientVariables.json";
import ContactActivity from "./ContactActivity";
import { CheckCircleOutlineOutlined } from "@mui/icons-material";

const Contacts = () => {
  const scrollRef = useRef(null);
  const { searchInput, searchType } = useSelector(companiesManagementSelector);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [jobshasmore, setjobshasmore] = useState(true);
  const [joboffset, setjoboffset] = useState(0);
  const [jobDetails, setJobDetails] = useState({});
  const [contacts, setContacts] = useState([]);
  const [contactId, setContactId] = useState("");
  const [contactJobs, setcontactJobs] = useState([]);
  const [selectedJobId, setselectedJobId] = useState("");
  const [contactDetails, setContactDetails] = useState({});
  const [verified, setVerified] = useState(false);
  const [showMailForm, setShowMailForm] = useState(false);
  const [sendMail, setSendMail] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [contactMailData, setContactMailData] = useState([]);
  const [contactActivityView, setContactActivityView] = useState("");
  const [showContactMail, setShowContactMail] = useState(false);
  const textStyle1 = {
    fontSize: "12px",
    marginLeft: "3px",
    cursor: "pointer",
    // textDecoration: 'underline',
    color: verified ? "green" : "inherit", // Change color to green if verified
  };
  const textStyle = {
    fontSize: "12px",
    marginLeft: "3px",
    cursor: "pointer",
    // textDecoration: 'underline',
    color: verified ? "green" : "inherit", // Change color to green if verified
  };
  const resetToScrollStart = () => {
    // Reset items to the initial state

    setcontactJobs([]);

    setjoboffset(0);
    setContactDetails({});
    setJobDetails({});

    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  };
  const fetchMoreData = () => {
    fetch(
      `${Key.domain_crm}/company/search_contact`,
      // `${Key.domain_crm}/company/get_Companies_List`
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ page: offset, contactName: searchInput }),
      }
    ).then((response) => {
      response.json().then((resdata) => {
        if (resdata.data.length === 0) {
          setHasMore(false);
        } else {
          setContacts((prevData) => [...prevData, ...resdata.data]);
          setOffset(offset + resdata.data.length);
        }
      });
    });
  };
  const searchContacts = () => {
    axios
      .post(`${Key.domain_crm}/company/search_contact`, {
        contactName: searchInput,
        page: 0,
      })
      .then((res) => {
        if (res.data.success === 1) {
          setContacts(res?.data?.data);
          setContactId(res?.data?.data[0].ID);
          getContactDetail(res?.data?.data[0].ID);
          setOffset(0 + res?.data?.data?.length);
          getContactJobs(res?.data?.data[0].ID, 0);
        }
      })
      .catch((error) => console.log(error));
  };
  const getContactDetail = (id) => {
    if (id !== 0) {
      axios
        .post(`${Key.domain_crm}/company/get_contact_detail`, {
          contact_id: id,
        })
        .then((resdata) => {
          resetToScrollStart();
          if (
            resdata?.data.success === 1 &&
            resdata?.data?.data?.contact_detail
          ) {
            setContactDetails(resdata?.data?.data?.contact_detail);
            // setselectedcontact(resdata?.data?.data?.contact_detail?.ID || 0);
          } else {
          }
        });
    }
  };
  useEffect(() => {
    if (searchType === "contact") {
      searchContacts();
    }
  }, [searchInput]);
  useEffect(() => {
    const elements = document.querySelectorAll(".job-description");

    elements.forEach((element) => {
      const childElements = element.querySelectorAll("*");
      childElements.forEach((childElement) => {
        childElement.style.fontSize = "12px";
      });
    });
  }, [jobDetails]);
  const getContactJobs = (contactID, offset) => {
    var joboffsetvalue = offset !== undefined ? offset : joboffset;
    axios
      .post(
        // 'http://localhost:9992/company/get_contact_jobs',
        `${Key.domain_crm}/company/get_contact_jobs`,
        {
          contact_id: contactID,
          page: 0,
        }
      )
      .then((resdata) => {
        if (resdata?.data?.data?.length > 0) {
          setjobshasmore(false);
        } else {
          if (parseInt(joboffsetvalue) === 0) {
            setcontactJobs(resdata?.data?.data?.contactJobs);
          } else {
            setcontactJobs((prevData) => [
              ...prevData,
              ...resdata?.data?.data?.contactJobs,
            ]);
          }
          setjoboffset(
            joboffsetvalue + resdata?.data?.data?.contactJobs?.length
          );
        }
        // if (parseInt(joboffsetvalue) === 0) {
        getContactJobDetail(resdata?.data?.data?.contactJobs[0].id);
        // }
        //   ///////////////////
        //   if (res.data.success === 1) {
        //     setcontactJobs(res?.data?.data)
        //   }
      })
      .catch((error) => console.log(error));
  };
  const getContactJobDetail = (jobId) => {
    axios
      .post(`${Key.domain_crm}/company/get_company_job_detail`, {
        job_id: jobId,
      })
      .then((resdata) => {
        if (resdata?.data.success === 1) {
          // setJobDetailsLoader(false);
          setJobDetails(resdata?.data?.data?.job_detail);
          setselectedJobId(jobId);
          let job_contact_id = resdata?.data?.data?.job_detail?.job_contact_id;
          // if (job_contact_id) {
          //   getContactDetail(resdata?.data?.data?.job_detail?.job_contact_id);
          //   setShowContacts(false);
          // }
          // else {
          //   setShowContacts(true);
          // }
        }
        //   else {
        //     setJobDetailsLoader(true);
        //   }
      });
  };
  const sendMailRecruiter = (contact) => {
    setSendMail(!sendMail);
    setShowMailForm(false);
    getContactMailData(contact);
  };
  const getContactMailData = (contact) => {
    axios
      .post(`${Key.domain_crm}/company/get_contact_mails_data`, {
        contact_id: contact.ID,
        user_id: sessionStorage.getItem("id"),
      })
      .then((resData) => {
        setContactMailData(resData.data.data);
      });
  };
  const handleSendMail = (contact) => {
    if (subject != "" && message != "") {
      try {
        axios
          .post(`${Key.domain_crm}/company/sendMail`, {
            contact_email: contact.EMP_CONTACT_EMAIL,
            subject: subject,
            message: message,
            userId: sessionStorage.getItem("id"),
            contactId: contact.ID,
            activityType: "email",
          })
          .then((resdata) => {
            setShowMailForm(false);
            setSubject("");
            setMessage("");
            setShowContactMail(false);
            getContactMailData(contact);
            if (resdata.data.success == 1) {
              var msg = "Mail sent";
              // toast(<ToastMessage message={msg} />);
            }
          })
          .catch((error) => console.error(error));
      } catch (err) {
        console.error(err);
      }
    } else {
      var msg = "Fields should not empty";
      // toast(<ToastMessage message={msg} />);
    }
  };
  const handleclicknotes = (item) => {
    if (item === "email") {
      setShowContactMail(true);
      setContactActivityView(item);
    } else {
      setShowContactMail(false);
      setSendMail(false);
      setContactActivityView(item);
    }
  };
  return (
    <Grid container spacing={1} style={{ marginTop: "-70px" }}>
      <Grid
        item
        xs={2}
        sm={2}
        md={2}
        className="leftsidegrid"
        style={{
          borderRightColor: "#000",

          padding: "0px",
          position: "fixed",
          width: "inherit",
        }}
      >
        <div className="card mt-1">
          <div
            variant="text"
            style={{
              fontWeight: "500",
              height: "45px",
              textAlign: "left",
              padding: "10px",
            }}
          >
            Contacts{" "}
            <StarIcon
              style={{
                fontSize: "medium",
                color: "rgb(0 0 0 / 70%)",
                marginLeft: "8px",
                marginTop: "-2px",
              }}
            />
          </div>
        </div>

        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        >
          <div ref={scrollRef}>
            <InfiniteScroll
              dataLength={contacts?.length}
              next={fetchMoreData}
              hasMore={hasMore}
              endMessage={
                <p style={{ textAlign: "center" }}>
                  <b>Yay! You have seen it all</b>
                </p>
              }
              height={570}
              className="infinityscroll"
              style={{ overflowY: "scroll", overflowX: "hidden" }}
              scrollableTarget="scrollableDiv"
              pullDownToRefreshThreshold={50}
            >
              {contacts &&
                contacts?.length > 0 &&
                contacts?.map((value, index) => (
                  <Card
                    key={index}
                    style={{
                      backgroundColor:
                        contactId === value.ID
                          ? "rgba(25, 118, 210, 0.08)"
                          : "white",
                    }}
                  >
                    <div className="p-2">
                      <div className="row">
                        <div className="col-2">
                          <ListItemAvatar>
                            <Avatar
                              className="comapnyimg"
                              style={{ backgroundColor: "rgb(169, 169, 169)" }}
                            >
                              <HiOutlineBuildingOffice />
                            </Avatar>
                          </ListItemAvatar>
                        </div>
                        <div
                          className="col-10 companiestitle"
                          style={{
                            color: "rgb(33 37 41 / 80%)",
                            fontSize: "12px",
                            fontWeight: 700,
                            cursor: "pointer",
                            paddingLeft: "22px",
                            paddingTop: "9px",
                          }}
                          onClick={() => {
                            setContactId(value.ID);
                            getContactJobs(value.ID);
                            getContactDetail(value.ID);
                          }}
                        >
                          <span title={value?.name}>
                            {value?.EMP_CONTACT_NAME?.length > 25
                              ? `${value.EMP_CONTACT_NAME.slice(0, 25)}...`
                              : value?.EMP_CONTACT_NAME}
                          </span>
                          <p
                            style={{
                              marginBottom: "0px",
                              fontSize: "9px",
                              fontWeight: "700",
                            }}
                          >
                            {value?.company_name !== ""
                              ? value.company_name
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Card>
                ))}
            </InfiniteScroll>
          </div>
        </List>
      </Grid>
      <Grid
        item
        xs={10}
        md={10}
        sm={10}
        className="rightsidegrid"
        style={{
          marginTop: "-6px",
          marginLeft: "257px",
          position: "fixed",
        }}
      >
        {/* jobs view */}
        <Grid container spacing={1}>
          <Grid item md={3}>
            <div>
              <Card style={{ height: "49px" }}>
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-12 col-lg-12 jobscolumn"
                    style={{ paddingTop: "8px", paddingLeft: "17px" }}
                  >
                    <div className="">
                      <div
                        variant="text"
                        style={{
                          marginTop: "1px",
                          fontWeight: "500",
                          padding: "3px",
                        }}
                      >
                        Contacts Posted Jobs{" "}
                        <StarIcon
                          style={{
                            fontSize: "medium",
                            color: "rgb(0 0 0 / 70%)",
                            marginLeft: "8px",
                            marginTop: "-2px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Card>

              <Card>
                <div ref={scrollRef}>
                  <InfiniteScroll
                    dataLength={contactJobs?.length}
                    next={getContactJobs}
                    hasMore={jobshasmore}
                    height={570}
                    className="infinityscroll"
                    style={{ overflowY: "scroll", overflowX: "hidden" }}
                    scrollableTarget="scrollableDiv"
                    pullDownToRefreshThreshold={50}
                  >
                    <div className="row">
                      {contactJobs?.length > 0 ? (
                        contactJobs.map((jobs, index) => (
                          <div
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              getContactJobDetail(jobs.id);
                              //   getJobDetail(jobs.id);
                              //   setselectedcontact(contact.ID);
                            }}
                          >
                            <List
                              sx={{
                                width: "100%",
                                maxWidth: 360,
                                bgcolor: "background.paper",
                              }}
                              style={{
                                paddingBottom: "0px",
                                paddingTop: "0px",
                                marginBottom: "0px",
                                // marginTop: '-11px',
                                backgroundColor:
                                  selectedJobId === jobs.id
                                    ? "rgba(25, 118, 210, 0.08)"
                                    : "white",
                              }}
                            >
                              <ListItem
                                alignItems="flex-start"
                                className="jobslist"
                              >
                                <ListItemAvatar>
                                  <Avatar
                                    style={{
                                      backgroundColor: "rgb(169, 169, 169)",
                                    }}
                                  >
                                    <BusinessCenterIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={
                                    <div>
                                      <div>
                                        <div className="jobtitle col-12">
                                          <Typography
                                            variant="body2"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "700",
                                              marginTop: "7px",
                                            }}
                                            title={jobs?.title}
                                          >
                                            {jobs?.title?.length > 25
                                              ? `${jobs.title.slice(0, 25)}...`
                                              : jobs?.title}
                                          </Typography>
                                        </div>
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "12px",
                                          marginTop: "6px",
                                        }}
                                      >
                                        {" "}
                                        {jobs?.jobtypeName?.slice(0, 15) ||
                                          "N/A"}
                                        {jobs?.jobtypeName?.length > 15
                                          ? "..."
                                          : ""}
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "400",
                                            marginTop: "-21px",
                                            display: "flex",
                                            justifyContent: "end",
                                          }}
                                        >
                                          {moment(jobs.modified).fromNow()}
                                        </span>
                                      </p>
                                      <p
                                        style={{
                                          fontSize: "12px",
                                          marginTop: "-13px",
                                        }}
                                      >
                                        {jobs?.location || "N/A"}{" "}
                                      </p>{" "}
                                    </div>
                                  }
                                />
                              </ListItem>
                            </List>
                          </div>
                        ))
                      ) : (
                        <div style={{ width: "900px" }}>
                          <center>
                            <p style={{ margin: "30px 0px" }}>No Jobs</p>
                            {/* <Skeleton />
                            <Skeleton count={70} /> */}
                          </center>
                        </div>
                      )}
                    </div>
                  </InfiniteScroll>
                </div>
              </Card>
            </div>
          </Grid>
          <Grid item md={6}>
            <CompanyJobDetail jobDetails={jobDetails} showContact={false} />
          </Grid>
          <Grid item md={3}>
            {/* contacts detail view */}

            <Card>
              <p
                style={{ height: "0px" }}
                onClick={() => {
                  setShowContacts(true);
                }}
              ></p>
              <div className="row">
                <div style={{ textAlign: "center" }}>
                  <div style={{ float: "right" }}></div>
                  <center>
                    <Avatar
                      style={{
                        height: "50px",
                        width: "50px",
                        top: "8px",
                        marginBottom: "14px",
                      }}
                      src={contactDetails && contactDetails?.EMP_PHOTO_URL}
                    >
                      <AccountCircleRoundedIcon />
                    </Avatar>
                  </center>
                  <h3 style={{ marginTop: "5px", fontSize: "15px" }}>
                    {contactDetails && contactDetails?.EMP_CONTACT_NAME}
                  </h3>
                  <p style={{ fontSize: "12px", marginBottom: "2px" }}>
                    Location&nbsp;:&nbsp;
                    {contactDetails.EMP_CONTACT_CITY &&
                    contactDetails.EMP_CONTACT_STATE_PROVINCE
                      ? `${contactDetails.EMP_CONTACT_CITY}, ${contactDetails.EMP_CONTACT_STATE_PROVINCE}`
                      : "N/A"}
                  </p>

                  {contactDetails &&
                    contactDetails?.EMP_LINKEDIN_URL !== "null" &&
                    contactDetails?.EMP_LINKEDIN_URL && (
                      <span>
                        <a
                          href={contactDetails.EMP_LINKEDIN_URL}
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                            color: "#000",
                            fontSize: "12px",
                          }}
                        >
                          <TbBrandLinkedin color="#212529" fontSize={"21px"} />{" "}
                          Linkedin Profile
                        </a>
                      </span>
                    )}

                  {contactDetails &&
                    contactDetails?.EMP_CONTACT_EMAIL !== "null" &&
                    contactDetails?.EMP_CONTACT_EMAIL && (
                      <p style={{ fontSize: "12px", marginBottom: "10px" }}>
                        {contactDetails?.EMP_CONTACT_EMAIL !== undefined &&
                        contactDetails?.EMP_CONTACT_EMAIL !== null
                          ? contactDetails?.EMP_CONTACT_EMAIL
                          : ""}
                        <span
                          variant="outlined"
                          onClick={() => updateEmailVerifyStatus("Email")}
                          style={{
                            ...textStyle,
                            backgroundColor: "#FFF",
                            borderRadius: "14px",
                            color:
                              contactDetails?.email_verified === 1
                                ? "rgb(102, 102, 102)"
                                : "rgb(102, 102, 102)",
                            cursor: "pointer",
                            border:
                              contactDetails?.email_verified === 1
                                ? "none"
                                : "1px solid lightgrey",
                            padding: "7px",
                            fontSize: "10px",
                            fontWeight: "500",
                          }}
                        >
                          {contactDetails?.email_verified === 1 ? (
                            <span
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#406882",
                                borderRadius: "12px",
                                color: "#FFF",
                                fontSize: "10px",
                                fontWeight: "500",
                                padding: "5px 10px",
                              }}
                            >
                              Verified{" "}
                              <CheckCircleOutlineOutlined
                                style={{
                                  fontSize: "16px",
                                  verticalAlign: "middle",
                                }}
                              />
                            </span>
                          ) : (
                            "Verify"
                          )}
                        </span>
                      </p>
                    )}

                  {contactDetails &&
                    contactDetails?.EMP_CONTACT_PHONE !== "null" &&
                    contactDetails?.EMP_CONTACT_PHONE && (
                      <p style={{ fontSize: "12px" }}>
                        {contactDetails?.EMP_CONTACT_PHONE !== undefined &&
                        contactDetails?.EMP_CONTACT_PHONE !== null
                          ? contactDetails?.EMP_CONTACT_PHONE
                          : ""}
                        <span
                          onClick={() => updateEmailVerifyStatus("Phone")}
                          style={{
                            ...textStyle1,
                            fontSize: "10px",
                            color:
                              contactDetails.phone_verified === 1
                                ? "#FFF"
                                : "rgb(102 102 102)",
                            fontWeight: "500",
                            backgroundColor:
                              contactDetails.phone_verified === 1
                                ? "#406882"
                                : "transparent",
                            border:
                              contactDetails.phone_verified === 1
                                ? "none"
                                : "1px solid lightgrey",
                            cursor: "pointer",
                            padding: "5px 10px", // Adjust padding as needed
                            borderRadius:
                              contactDetails.phone_verified === 1
                                ? "14px"
                                : "14px", // Set border radius conditionally
                          }}
                        >
                          {contactDetails.phone_verified === 1 ? (
                            <>
                              Verified{" "}
                              <CheckCircleOutlineOutlined
                                style={{
                                  fontSize: "16px",
                                  verticalAlign: "middle",
                                }}
                              />
                            </>
                          ) : (
                            "Verify"
                          )}
                        </span>
                      </p>
                    )}

                  <div
                    style={{
                      marginLeft: "12px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginRight: "20px",
                      }}
                      onClick={() => handleclicknotes("call")}
                    >
                      <img src={Call} width={"32px"} />
                      <p style={{ fontSize: "13px" }}>Call</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginRight: "20px",
                      }}
                      onClick={() => handleclicknotes("text")}
                    >
                      <img src={Chat} width={"32px"} />
                      <p style={{ fontSize: "13px" }}>Text</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginRight: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleclicknotes("email")}
                    >
                      <img
                        src={Email}
                        width={"32px"}
                        onClick={() => sendMailRecruiter(contactDetails)}
                      />
                      <p style={{ fontSize: "13px" }}>Email</p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginRight: "20px",
                        cursor: "pointer",
                      }}
                    >
                      <img src={Tag} width={"32px"} />
                      <p style={{ fontSize: "13px" }}>Tag Job</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginRight: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleclicknotes("note")}
                    >
                      <img src={Note} width={"32px"} />
                      <p style={{ fontSize: "13px" }}>Notes</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div>
                  {sendMail ? (
                    !showMailForm ? (
                      <Container style={{ padding: "0px" }}>
                        <ul style={{ paddingLeft: "10px" }}>
                          <Card
                            style={{
                              padding: "5px",
                              height: "150px",
                              overflow: "auto",
                            }}
                          >
                            <Card.Title style={{ fontSize: "16px" }}>
                              Mails Log
                            </Card.Title>
                            {contactMailData.length > 0 ? (
                              contactMailData.map((item, index) => (
                                <li
                                  key={index}
                                  style={{
                                    marginLeft: "4px",
                                    listStyleType: "none",
                                  }}
                                >
                                  <Card
                                    style={{
                                      padding: "5px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          marginRight: "2px",
                                        }}
                                      >
                                        Subject :
                                      </span>
                                      {item.subject !== "" &&
                                      item.subject !== null
                                        ? `${
                                            item.subject[0].toUpperCase() +
                                            item.subject.slice(1, 20)
                                          }`
                                        : "N/A"}
                                      <span
                                        style={{
                                          float: "right",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment(item.created).fromNow()}
                                      </span>
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          marginRight: "2px",
                                        }}
                                      >
                                        Message :
                                      </span>
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setShowContactMessage(true);
                                          setContactMailMessage(item.message);
                                          setContactMailSubject(item.subject);
                                        }}
                                      >
                                        {item?.message !== "" &&
                                        item?.message.length > 0 &&
                                        item?.message?.length > 20
                                          ? `${
                                              item.message[0].toUpperCase() +
                                              item.message.slice(1, 20)
                                            }...`
                                          : item.message[0]?.toUpperCase() +
                                            item.message.slice(1)}
                                      </span>
                                    </p>
                                    {/* <span style={{ fontSize: '12px' }}>{item.message[0].toUpperCase()+item.message.slice(1, 20)}</span> */}
                                  </Card>
                                </li>
                              ))
                            ) : (
                              <p
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                  margin: "auto",
                                }}
                              >
                                No Mails Log
                              </p>
                            )}
                          </Card>
                        </ul>

                        <Button
                          // variant="secondary"
                          style={{
                            fontSize: "12px",
                            marginTop: "10px",
                            marginBottom: "10px",
                            marginRight: "12px",
                            backgroundColor: "#fff",
                            color: "#000",
                            border: "1px solid gray",
                            float: "right",
                          }}
                          onClick={() => {
                            setShowMailForm(true);
                          }}
                        >
                          Send Mail
                        </Button>
                      </Container>
                    ) : (
                      <>
                        <Container>
                          <Form>
                            <Form.Group>
                              <Form.Label style={{ fontSize: "12px" }}>
                                Subject
                              </Form.Label>
                              <Form.Control
                                type="text"
                                class="form-control"
                                placeholder="Enter Subject"
                                name="subject"
                                onChange={(e) => setSubject(e.target.value)}
                                value={subject}
                              />
                              <Form.Label style={{ fontSize: "12px" }}>
                                Message
                              </Form.Label>
                              <textarea
                                class="form-control"
                                placeholder="Enter Message"
                                id="exampleFormControlTextarea1"
                                rows="3"
                                onChange={(e) => setMessage(e.target.value)}
                                value={message}
                              ></textarea>
                            </Form.Group>

                            <Button
                              style={{
                                fontSize: "12px",
                                float: "right",
                                marginTop: "10px",
                                marginBottom: "10px",
                                marginLeft: "12px",
                                backgroundColor: "#fff",
                                color: "#000",
                                border: "1px solid gray",
                              }}
                              onClick={(e) => {
                                handleSendMail(contactDetails);
                              }}
                            >
                              Send
                            </Button>
                          </Form>
                        </Container>
                      </>
                    )
                  ) : (
                    <ContactActivity
                      viewComponent={contactActivityView}
                      contactDetails={contactDetails}
                    />
                  )}
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Contacts;
